import { render, staticRenderFns } from "./ChangeParentDialog.vue?vue&type=template&id=6b0d99d3&scoped=true&"
import script from "./ChangeParentDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeParentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangeParentDialog.vue?vue&type=style&index=0&id=6b0d99d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d99d3",
  null
  
)

export default component.exports